import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import SectionContainer from "../../../components/sectionContainer/sectionContainer";
import { actionCreators } from "./redux/sagas/membershipDetails/membershipDetails";
import { isModuleActive } from "../../../utils/modules";
import { configuratorStore } from "../dashboardConfigurator/dashboard";
import { configuratorMonthSwitcherStore } from "../monthSwitcherModule/monthSwitcher";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import ActiveMembersStats from "./smartComponents/activeMembersStats";
import ActiveMembersChange from "./smartComponents/activeMembersChange";
import ActiveMembersStatsPrevious from "./smartComponents/activeMembersStatsPrevious";
import CancelledMembersStats from "./smartComponents/cancelledMembersStats";
import CancelledMembersChange from "./smartComponents/cancelledMembersChange";
import CancelledMembersStatsPrevious from "./smartComponents/cancelledMembersStatsPrevious";
import NewMembersStats from "./smartComponents/newMembersStats";
import NewMembersChange from "./smartComponents/newMembersChange";
import NewMembersStatsPrevious from "./smartComponents/newMembersStatsPrevious";
import FrozenMembersStats from "./smartComponents/frozenMembersStats";
import FrozenMembersChange from "./smartComponents/frozenMembersChange";
import FrozenMembersStatsPrevious from "./smartComponents/frozenMembersStatsPrevious";
import AttritionRateStats from "./smartComponents/attritionRateStats";
import AttritionRateChange from "./smartComponents/attritionRateChange";
import NetUnitMtdStats from "./smartComponents/netUnitMtdStats";
import NetUnitMtdChange from "./smartComponents/netUnitMtdChange";
import NetUnitMtdStatsPrevious from "./smartComponents/netUnitMtdStatsPrevious";
import MembershipDetailsChart from "./smartComponents/membershipDetailsChart";
import { getToolTip } from "../../../utils/getToolTip";
import LearnMore from "../../../components/learnMore/learnMore";

export class MembershipDetailsModule extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      initRequest: false,
      moduleHeight: 800
    };
  }

  componentDidMount() {
    if (isModuleActive(this.props.currentUser.dashboardPreferences, "Membership Sales")) {
      this.props.fetchCurrentUser({ user: this.props.currentUser });

      this.setState({
        initRequest: true
      });
    }

    // Dashboard configurator store
    configuratorStore.subscribe(() => {
      const state = configuratorStore.getState();
      if (isModuleActive(state.dashboardConfigurator.preferences, "Membership Sales") && !this.state.initRequest) {
        const { monthSwitcher } = configuratorMonthSwitcherStore.getState();

        this.props.fetchCurrentUser({ user: this.props.currentUser, date: monthSwitcher.date });
        this.setState({
          initRequest: true
        });
      }
    });

    // Month switcher store
    let previousDate;
    configuratorMonthSwitcherStore.subscribe(() => {
      if (this.state.initRequest) {
        const currentDate = configuratorMonthSwitcherStore.getState().monthSwitcher.date;

        if (currentDate !== previousDate) {
          previousDate = currentDate;
          this.props.updateAllData(currentDate);
        }
      }
    });
  }

  renderContent = () => {
    return (
      <div>
        <div className="section-group-container">
          <div className="section-group">
            <span className="width-50">
              <SectionContainer title="Active Members" toolTip={this.props.activeMembersToolTip} toolTipId="membershipDetailsActiveMembers">
                <ActiveMembersStats />
                <ActiveMembersChange />
              </SectionContainer>
            </span>
            <span className="width-50">
              <SectionContainer
                title="Previous Active Members"
                toolTip={`Previous ${this.props.activeMembersToolTip}`}
                toolTipId="membershipDetailsPreviousActiveMembers"
              >
                <ActiveMembersStatsPrevious />
              </SectionContainer>
            </span>
          </div>

          <div className="section-group">
            <span className="width-50">
              <SectionContainer title="Cancelled Members" toolTip={this.props.cancelledMembersToolTip} toolTipId="membershipDetailsCancelledMembers">
                <CancelledMembersStats />
                <CancelledMembersChange />
              </SectionContainer>
            </span>
            <span className="width-50">
              <SectionContainer
                title="Previous Cancelled Members"
                toolTip={`Previous ${this.props.cancelledMembersToolTip}`}
                toolTipId="membershipDetailsPreviousCancelledMembers"
              >
                <CancelledMembersStatsPrevious />
              </SectionContainer>
            </span>
          </div>
        </div>

        <div className="section-group-container">
          <div className="section-group">
            <span className="width-50">
              <SectionContainer title="New Members" toolTip={this.props.newMembersToolTip} toolTipId="membershipDetailsNewMembers">
                <NewMembersStats />
                <NewMembersChange />
              </SectionContainer>
            </span>
            <span className="width-50">
              <SectionContainer
                title="Previous New Members"
                toolTip={`Previous ${this.props.newMembersToolTip}`}
                toolTipId="membershipDetailsPreviousNewMembers"
              >
                <NewMembersStatsPrevious />
              </SectionContainer>
            </span>
          </div>

          <div className="section-group">
            {this.props.displayFrozen === true ? (
              <>
                <span className="width-50">
                  <SectionContainer title="Frozen Members" toolTip={this.props.frozenMembersToolTip} toolTipId="membershipDetailsFrozenMembers">
                    <FrozenMembersStats />
                    <FrozenMembersChange />
                  </SectionContainer>
                </span>
                <span className="width-50">
                  <SectionContainer
                    title="Previous Frozen Members"
                    toolTip={`Previous ${this.props.frozenMembersToolTip}`}
                    toolTipId="membershipDetailsPreviousFrozenMembers"
                  >
                    <FrozenMembersStatsPrevious />
                  </SectionContainer>
                </span>
              </>
            ) : (
              ""
            )}
          </div>
        </div>

        <div className="section-group-container">
          <div className="section-group">
            <span className="width-50">
              <SectionContainer title="Net Units MTD" toolTip={this.props.newUnitsToolTip} toolTipId="membershipNewUnitsToolTipMTD">
                <NetUnitMtdStats />
                <NetUnitMtdChange />
              </SectionContainer>
            </span>
            <span className="width-50">
              <SectionContainer
                title="Previous Net Units MTD"
                toolTip={`Previous ${this.props.newUnitsToolTip}`}
                toolTipId="membershipPreviousNewUnitsMTDToolTip"
              >
                <NetUnitMtdStatsPrevious />
              </SectionContainer>
            </span>
          </div>

          <div className="section-group">
            <span className="width-50">
              <SectionContainer title="ATTRITION RATE" toolTip={this.props.attritionRateToolTip} toolTipId="membershipDetailsAttritionRate" isToolTipHtml>
                <AttritionRateStats />
                <AttritionRateChange />
              </SectionContainer>
            </span>
          </div>
        </div>

        <div className="section-group" style={{ height: "350px", width: "100%" }}>
          <MembershipDetailsChart />
        </div>
      </div>
    );
  };

  render() {
    const { learnMoreId, title, content } = this.props.learnMore;
    return (
      <SectionToggle
        title="Membership Sales"
        learnMore={<LearnMore learnMoreId={learnMoreId} title={title} content={content} html />}
        customClass={`membershipsalesWidget ${this.props.isLoading ? "" : "active"}`}
        height={this.state.moduleHeight}
        isLoading={this.props.isLoading}
        content={this.renderContent()}
      />
    );
  }
}

export default connect(
  state => ({
    isLoading: state.membershipDetails.isLoading,
    userParams: state.membershipDetails.currentUser,
    statistics: state.membershipDetails.statistics,
    activeMembersToolTip: state.membershipDetails.statistics.activeMembers.tooltip,
    cancelledMembersToolTip: state.membershipDetails.statistics.cancelledMembers.tooltip,
    attritionRateToolTip: state.membershipDetails.statistics.churnRate.tooltip,
    newMembersToolTip: state.membershipDetails.statistics.newMembers.tooltip,
    frozenMembersToolTip: state.membershipDetails.statistics.frozenMembers.tooltip,
    displayFrozen: state.membershipDetails.statistics.displayFrozen,
    newUnitsToolTip: getToolTip(state.membershipDetails.statistics)
  }),
  {
    fetchCurrentUser: actionCreators.fetchCurrentUser,
    updateAllData: actionCreators.updateAllData
  }
)(MembershipDetailsModule);

MembershipDetailsModule.propTypes = {
  fetchCurrentUser: PropTypes.func.isRequired,
  updateAllData: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  currentUser: PropTypes.object,
  activeMembersToolTip: PropTypes.string,
  cancelledMembersToolTip: PropTypes.string,
  newMembersToolTip: PropTypes.string,
  frozenMembersToolTip: PropTypes.string,
  attritionRateToolTip: PropTypes.string,
  newUnitsToolTip: PropTypes.string,
  learnMore: PropTypes.objectOf(PropTypes.string),
  displayFrozen: PropTypes.bool
};
